import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import "flatpickr/dist/themes/material_blue.css"
import { API_URL } from "../../../helpers/app_url";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  CardHeader,
  CardTitle
} from "reactstrap"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import EligibilitypagesMenu from "../menu/eligibilitypages-menu";
import LeadEligibilityBreadcrumb from "components/Common/LeadEligibilityBreadcrumb";
import SaveButton from "components/buttons/save";
import axios from "axios";
import img1 from "../../../assets/img/doc-1.png"
import img2 from "../../../assets/img/doc-2.png"
import img3 from "../../../assets/img/doc-3.png"
import SafeField from "helpers/SafeField";
class DecisionEligibility extends Component {
  constructor(props) {
    super(props)
    this.state = {
      questions: ''
    }

  }
  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (!obj || !obj.resultData) return;

    const token = obj.resultData.bearerToken;
    const str = "Bearer " + token;
    const userId = localStorage.getItem("userId");
    if (!userId) return;

    axios
      .get(API_URL + `QualificationQuestion/allagentQualificationSpecificQuestionAnswers?agentId=${userId}&question=Decision Stage`, {
        headers: { Authorization: str },
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          const questions = res.data[0];
          if (questions && questions.answers) {
            // Helper function to safely find answers
            const findScoringValue = (answer) => {
              const foundAnswer = questions.answers.find((a) => a.answer === answer);
              return foundAnswer ? foundAnswer.scoringValue : null;
            };

            this.setState({
              questions: {
                id: questions.id,
                qualificationQuestionId: questions.qualificationQuestionId,
                weightage: questions.weightage,
                answers: questions.answers,
                within1Month: findScoringValue("Within 1 Month"),
                within2Month: findScoringValue("Within 2 Months"),
                within3Month: findScoringValue("Within 3 Months"),
                within3to6Months: findScoringValue("Within 3-6 Months"),
                moreThan6Months: findScoringValue("More than 6 months"),
              },
            });
          }
        } else {
          console.warn("No questions found.");
        }
      })
      .catch((error) => {
        console.error("Error fetching questions:", error);
      });
       //
  }

 
 
handleSubmit = (values, { setSubmitting }) => {
  const userId = parseInt(localStorage.getItem("userId"));

  const getAnswerObj = (label, value) => {
    const answerObj = this.state.questions?.answers?.find((a) => a.answer === label);
    return {
      id: answerObj?.id || 0,
      agentId: userId,
      questionId: answerObj?.questionId || this.state.questions?.id || 0,
      answer: label,
      scoringType: 0,
      scoringValue: parseInt(value) || 0,
      isActive: true,
    };
  };

  const questionAnswers = [
    getAnswerObj("Within 1 Month", values.within1Month),
    getAnswerObj("Within 2 Months", values.within2Month),
    getAnswerObj("Within 3 Months", values.within3Month),
    getAnswerObj("Within 3-6 Months", values.within3to6Months),
    getAnswerObj("More than 6 months", values.moreThan6Months),
  ];

  const submissionData = {
    createQualificationBulkQuestionWithAnswersList: [
      {
        id: this.state.questions?.id || 0,
        agentId: userId,
        weightage: parseInt(values.weightage) || 0,
        question: "Decision Stage",
        primaryScoringValue: 0,
        secondaryScoringValue: 0,
        otherScoringValue: 0,
        isActive: true,
        questionAnswers,
      },
    ],
  };

  //

 
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj.resultData.bearerToken;
  const str = "Bearer " + token;

  toast.loading("Please wait...");
  axios
    .post(
      API_URL + `QualificationQuestion/AddUpdateQualificationBulkQuestionAnswers`,
      submissionData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: str,
        },
      }
    )
    .then((response) => {
      toast.dismiss();
      if (response.data.success) {
        toast.success("Saved successfully");
      } else {
        toast.error("Some error occurred");
      }
    })
    .catch((error) => {
      toast.dismiss();
      toast.error("Error submitting form");
      console.error("Error submitting form:", error);
    })
    .finally(() => {
      setSubmitting(false);
    });
  
};



  render() {

    return (
      <React.Fragment>

        <ToastContainer autoClose={2000} />

        <div className="page-content project-page-content">
          <MetaTags>
            <title>Eligibility Questions | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 pe-0">


            <Row className="mb20 project-header">
              <Col xl="6">
                <LeadEligibilityBreadcrumb
                  title={this.props.t("Lead")}

                  breadcrumbItem={this.props.t("Decision Stage")}
                />

              </Col>

            </Row>
            <Row>


              <Col xl="12">

                <Card>
                  <CardBody>
                    <EligibilitypagesMenu />
                    <Row className="align-items-stretch">
                      <Col sm="5">
                        <Formik
                          enableReinitialize={true}
                          initialValues={{
                            weightage: this.state.questions.weightage || "",
                            within1Month: this.state.questions.within1Month || "",
                            within2Month: this.state.questions.within2Month || "",
                            within3Month: this.state.questions.within3Month || "",
                            within3to6Months: this.state.questions.within3to6Months || "",
                            moreThan6Months: this.state.questions.moreThan6Months || "",

                          }}
                          validationSchema={Yup.object().shape({
                            weightage: Yup.number().required("This is required").typeError("Enter valid number"),
                            within1Month: Yup.number().required("This is required").typeError("Enter valid number"),
                            within2Month: Yup.number().required("This is required").typeError("Enter valid number"),
                            within3Month: Yup.number().required("This is required").typeError("Enter valid number"),
                            within3to6Months: Yup.number().required("This is required").typeError("Enter valid number"),
                            moreThan6Months: Yup.number().required("This is required").typeError("Enter valid number"),


                          })}

                          onSubmit={this.handleSubmit}
                        >
                          {({ errors, touched, values, handleChange, setFieldValue }) => (
                            <Form
                              className="needs-validation"
                            >
                              <Card className="border-brk mt-40">
                                <CardHeader>
                                  <CardTitle>Step 1 : How important is the decision stage in the overall eligibility score.</CardTitle>
                                  <CardBody>
                                    <Row>


                                      <Col md="2">
                                        <FormGroup className="mb-3">

                                          <SafeField
                                            name="weightage"
                                            className={
                                              "form-control" +
                                              (errors.weightage && touched.weightage
                                                ? " is-invalid"
                                                : "")
                                            }
                                            onChange={handleChange}
                                            type="text"
                                          />
                                          <ErrorMessage
                                            name="weightage"
                                            component="div"
                                            className="invalid-feedback"
                                          />

                                        </FormGroup>
                                      </Col>
                                      <Col sm="10">

                                        (Assign a numerical value (1-10) to indicate how important location is in your overall lead evaluation. A higher value means higher importance.)

                                      </Col>
                                    </Row>

                                  </CardBody>
                                </CardHeader>
                              </Card>
                              <Card className="border-brk mt-40">
                                <CardHeader>
                                  <CardTitle>Step 2 : Assign scores for different decision timeframes</CardTitle>
                                  <p> (Assign a numerical value (1-100) to indicate how important “Decision stage” of the buyer in your overall lead evaluation. A higher value means higher importance.)</p>

                                  <Row>
                                    <Col md="3">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="within1Month">
                                          {this.props.t("Within 1 month")}
                                        </Label>

                                      </FormGroup>
                                    </Col>
                                    <Col md="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="within1Month"
                                          className={
                                            "form-control" +
                                            (errors.within1Month && touched.within1Month ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="within1Month"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="1"></Col>

                                  </Row>
                                  <Row>
                                    <Col md="3">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="within2Month">
                                          {this.props.t("Within 2 month")}
                                        </Label>

                                      </FormGroup>
                                    </Col>
                                    <Col md="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="within2Month"
                                          className={
                                            "form-control" +
                                            (errors.within2Month && touched.within2Month ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="within2Month"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="1"></Col>

                                  </Row>
                                  <Row>
                                    <Col md="3">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="within3Month">
                                          {this.props.t("Within 3 month")}
                                        </Label>

                                      </FormGroup>
                                    </Col>
                                    <Col md="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="within3Month"
                                          className={
                                            "form-control" +
                                            (errors.within3Month && touched.within3Month ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="within3Month"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="1"></Col>

                                  </Row>
                                  <Row>
                                    <Col md="3">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="within3to6Months">
                                          {this.props.t("Within 3-6 month")}
                                        </Label>

                                      </FormGroup>
                                    </Col>
                                    <Col md="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="within3to6Months"
                                          className={
                                            "form-control" +
                                            (errors.within3to6Months && touched.within3to6Months ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="within3to6Months"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="1"></Col>

                                  </Row>
                                  <Row>
                                    <Col md="3">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="addNote">
                                          {this.props.t("more than 6 month")}
                                        </Label>

                                      </FormGroup>
                                    </Col>
                                    <Col md="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="moreThan6Months"
                                          className={
                                            "form-control" +
                                            (errors.moreThan6Months && touched.moreThan6Months ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="moreThan6Months"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="1"></Col>

                                  </Row>

                                  <SaveButton>Save</SaveButton>
                                </CardHeader>
                              </Card>


                            </Form>
                          )}
                        </Formik>
                      </Col>
                      <Col sm="1" className="d-flex align-items-stretch justify-content-center">
                        <div className="vertical-line"></div>
                      </Col>

                      <Col sm="6">
                        <div className="link-page">

                          <div className="open-bg">
                          <h4><img src={img3} width="32px" /> Purpose</h4>
                            <ul className="no-list-type">
                              <li>The Decision Stage helps you identify how soon a lead plans to make a purchase. This insight allows you to prioritize more urgent buyers and follow up accordingly — ensuring you&apos;re spending time where it matters most. </li>

                               <li><strong>Step 1: Set Importance Level</strong><br/>
                               Decide how important the decision timeline is in your overall lead evaluation. If speed to close is an important for your business, set this factor to high importance. 
                               
                               </li>

                                <li><strong>Step 2: Assign Scores Based on Time Frame </strong><br/>
                               Assign scores to each decision stage that reflect how it fits into your sales approach. 

                               <br/>
                               <strong>For example:</strong> If you prefer working with buyers planning to move in 3–6 months, you can give that range the highest score or 
                               <br/>
                               If you prefer working with buyers planning to move in 3–6 months, you can give that range the highest score. 
                               
                               </li>
                            </ul>
                        
                          </div>
                        </div>
                      </Col>
                    </Row>
                   
                  </CardBody>
                </Card>




              </Col>

            </Row>



          </Container>
        </div>
      </React.Fragment>
    )
  }
}
DecisionEligibility.propTypes = {
  t: PropTypes.any,



}
const mapStateToProps = ({ }) => (
  {



  })
const mapDispatchToProps = dispatch => ({



});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DecisionEligibility))
